module.exports = __webpack_public_path__ + "static/img/logo.5c63a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/logo.png
// module id = 2QCe
// module chunks = 4